import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
interface Res {
  success:boolean,
  message:string
}
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {
  matcher = new MyErrorStateMatcher();
  constructor(
    private http:HttpClient,
    private fb:FormBuilder,
    private _snackBar: MatSnackBar
  ) { }
    helpDesk = this.fb.group({
      fullName:["",Validators.required],
      clientMail:["",Validators.email],
      concern:["",Validators.required]
    })
  ngOnInit(): void {
  }
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*"
    })
  }
  onHelpDeskSubmit(){
    console.log(this.helpDesk.value)
    const mailInfo = this.helpDesk.value
    this.http.post<Res>('https://us-central1-nplus2k20.cloudfunctions.net/sendMailToNaresh',mailInfo,this.httpOptions).subscribe( res=>{
      if(res.success){
        this._snackBar.open(res.message, 'Success!', {
          duration: 3000,
          panelClass: ['custom-snackbar']
        });
      } else {
        console.log(res.message)
        this._snackBar.open(res.message, 'Failed!', {
          duration: 1000,
          panelClass: ['custom-snackbar']
        });
      }
    }

    )
  }

}
